import React, {useContext} from "react";
import { GlobalDataContext } from "../../context/context";

const TransparentHeader = ({ headertitle, bgimg, Subheader, svgClass }) => {
  const {rpdata} = useContext(GlobalDataContext)
  return (
    <div
      className={`w-full h-[85vh] ${svgClass ? svgClass : 'svgHexagonInverso' } bg-cover bg-center bg-no-repeat relative before:absolute before:bg-[#00000091] before:w-full before:h-full`}
      style={{ 
        backgroundImage: `url("${bgimg}")`,
        backgroundAttachment:'fixed'
        }}
    >
      <div className="flex flex-col  h-full pb-20 pt-0 md:pt-40 md:pb-0 justify-end md:justify-center items-center relative">
        <h1 className="text-white lg:mt-28">{headertitle}</h1>
        {
          headertitle === Subheader ?
            <h6 className="text-white">
            {
              !rpdata?.spanishVersion?.isActive ?
              <span>Inicio - {Subheader}</span>
              :
              <span>Home - {Subheader}</span>
            }
            
            </h6>
            :
            <h6 className="text-white">{Subheader}</h6>
        }
      </div>
    </div>
  );
};

export default TransparentHeader;
